<template>
  <button class="navigate-big-button">
    <div
      v-if="$slots['icon'] != null"
      class="navigate-big-button-icon relative inline-block align-middle mr-2 select-none"
      style="font-size:1.2em;width:1.2em;height:1.2em;"
    >
      <slot name="icon"></slot>
    </div>
    <span class="inline-block align-middle select-none"
      ><slot name="label"></slot
    ></span>
  </button>
</template>

<script>
/**
 * Large dark gray button with icon
 */
export default {
  name: "NavigateBigButton"
};
</script>

<style scoped>
/*
.navigate-big-button::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  border-radius: 0.75rem;
  transition: width 0.2s ease-out;
  opacity: 0.2;
  background-color: white;
  pointer-events: none;
}
#app.mouse .navigate-big-button:hover::after,
.navigate-big-button:active::after {
  width: 100%;
}
*/
</style>
